angular.module('vehicle-issue')
    .constant('VehicleIssueConst', {
        eventUpdate: 'vehicle-issue.updated',
        tpl: 'app/vehicle-issue/'
    })
